import { render, staticRenderFns } from "./EditTipocontratoPage.vue?vue&type=template&id=28f8e164"
import script from "./EditTipocontratoPage.vue?vue&type=script&lang=js"
export * from "./EditTipocontratoPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports